<div class="header">
<a href="/">
    <img src="https://www.decathlon.be/assets/images/decathlon-logo.svg"/>
</a>
<mat-divider [vertical]="true"></mat-divider>
<div class="title">{{title}}</div>
</div>
<app-product-configurator></app-product-configurator>
